import { Expose } from "class-transformer";
import { IsNumber, IsOptional, IsString } from "class-validator";

export class ModifyBankStatementItem {
  @Expose()
  @IsNumber()
  amount!: number; // 1500
  @Expose()
  @IsNumber()
  amountAfterChange!: number; // 1500
  @Expose()
  @IsNumber()
  amountLeft!: number; // 1500
  @Expose()
  @IsNumber()
  amountLeftAfterChange!: number; // 1500
  @Expose()
  @IsOptional()
  @IsString()
  comment!: null | string;
  @Expose()
  @IsString()
  currency!: string; // "PLN"
  @Expose()
  @IsString()
  message!: string; // ""
  @Expose()
  @IsNumber()
  modifyValue!: number; // 0
}
